import './App.css';
import logo from './logo.png';
import React from 'react';
import supabase from './supabase';

function Signup() {
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [btn, setBtn] = React.useState('Signup');

  const handleSignup = async () => {
    setBtn('Loading...');
    const { data, error } = await supabase.from('users').insert({ email, password });
    if (error) {
      alert(error.message);
      setBtn('Signup');
    } else {
      window.location.href = '/login';
    }
  };



  return (
    <div className='flex flex-col items-center justify-between min-h-screen bg-parentPurple py-12'>
      <img src={logo} alt='logo' className='w-24' />
      <div className='flex flex-col items-center space-y-4 w-11/12 md:w-4/6 lg:w-2/6'>
        <h1 className='font-bold text-3xl tracking-wide text-myYellow mb-6'>
          Signup
        </h1>
        <div className='flex flex-col w-full items-center space-y-4'>
          <input
            type='text'
            placeholder='Email'
            className='w-full p-4 rounded-md focus:outline-none focus:ring-2 focus:ring-myYellow/50 transition-all ease-in resize-none bg-myPurple/20 border border-myYellow text-myYellow placeholder:text-myYellow/60'
          />
          <input
            type='password'
            placeholder='Password'
            className='w-full p-4 rounded-md focus:outline-none focus:ring-2 focus:ring-myYellow/50 transition-all ease-in resize-none bg-myPurple/20 border border-myYellow text-myYellow placeholder:text-myYellow/60'
          />
          <button 
            onClick={handleSignup}
          className='w-full bg-myYellow text-parentPurple font-bold rounded-md py-4 text-lg'>
            {btn}
          </button>
        </div>
        <a href='/login' className='text-myYellow'>
          Already have an account? Login
        </a>
      </div>
      <div></div>
    </div>
  );
}

export default Signup;
